var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisibilityHidden(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.40499 13.2622C4.22306 13.0021 4.12549 12.6924 4.12549 12.375C4.12549 12.0576 4.22306 11.7479 4.40499 11.4878C5.58474 9.8175 8.48949 6.375 12.3752 6.375C16.261 6.375 19.1657 9.8175 20.3455 11.4878C20.5274 11.7479 20.625 12.0576 20.625 12.375C20.625 12.6924 20.5274 13.0021 20.3455 13.2622C19.1657 14.9325 16.261 18.375 12.3752 18.375C8.48949 18.375 5.58474 14.9325 4.40499 13.2622Z",
    fill: "#F3F3F3",
    stroke: "#B3B3B3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 15.375C14.0319 15.375 15.375 14.0319 15.375 12.375C15.375 10.7181 14.0319 9.375 12.375 9.375C10.7181 9.375 9.375 10.7181 9.375 12.375C9.375 14.0319 10.7181 15.375 12.375 15.375Z",
    stroke: "#B3B3B3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 19.875L19.875 4.875",
    stroke: "#B3B3B3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityHidden);
export default __webpack_public_path__ + "static/media/VisibilityHidden.22697f10a69f505331ab7a0a5db3b43e.svg";
export { ForwardRef as ReactComponent };